import React, { useState, useEffect } from "react";
import { Marker } from "@react-google-maps/api";
import mapPin from "../../assets/images/map-pin.svg";
import mapPinNational from "../../assets/images/map-pin-national.svg";
import mapPinSelected from "../../assets/images/map-pin-selected.svg";
import mapPinNationalSelected from "../../assets/images/map-pin-national-selected.svg";

const MapMarker = props => {
  const {
    location,
    initLoad,
    markerLoadHandler,
    markerClickUpdate,
    selectedResult,
    togglePinsOff
  } = props;
  const [iconURL, setIconURL] = useState(
    location.Type === "National" ? mapPinNational : mapPin
  );

  const markerClickHandler = (marker, location) => {
    setIconURL(mapPinSelected);
    markerClickUpdate(marker, location);
  };

  useEffect(() => {
    if (togglePinsOff)
      setIconURL(location.Type === "National" ? mapPinNational : mapPin);
  }),
    [togglePinsOff];

  useEffect(() => {
    if (selectedResult.id === location.ID) {
      setIconURL(
        location.Type === "National" ? mapPinNationalSelected : mapPinSelected
      );
    } else {
      setIconURL(location.Type === "National" ? mapPinNational : mapPin);
    }
  }, [selectedResult]);

  return (
    <Marker
      position={{
        lat: location.Latitude,
        lng: location.Longitude
      }}
      onLoad={initLoad ? marker => markerLoadHandler(marker, location) : null}
      onClick={marker => markerClickHandler(marker, location)}
      icon={{
        url: iconURL,
        scaledSize:
          selectedResult.id === location.ID
            ? new window.google.maps.Size(36, 83)
            : new window.google.maps.Size(23, 30)
      }}
    />
  );
};

export default MapMarker;
